import { v4 as uuidv4 } from "uuid";
export function addIdToArrayElements(items, idKey = "id") {
    return items.map(item => ({
        ...item,
        [idKey]: uuidv4()
    }));
}
